'use strict';

require('./main.scss');